// src/json/servicesOverview.json
export const servicesOverviewWindowsCleaning = {
    eyebrow: "OUR WINDOW CLEANING SERVICES",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "High-Rise & Mid-Rise Window Cleaning",
            description: "Expert rope-access and suspended platform cleaning for tall buildings, condos, and office towers."
        },
        {
            title: "Commercial Window Cleaning",
            description: "Spotless cleaning for storefronts, retail spaces, hotels, and office buildings to maintain a professional image."
        },
        {
            title: "Post-Construction Window Cleaning",
            description: "Removing dust, debris, and adhesive residues left behind after renovations or new construction."
        },
        {
            title: "Hard Water Stain & Mineral Deposit Removal",
            description: "Eliminating streaks, etching, and buildup caused by rain, sprinklers, and pollution."
        },
        {
            title: "Skylight & Glass Canopy Cleaning",
            description: "Safely restoring clarity and brightness to skylights, glass atriums, and overhead installations."
        }
    ],
    imageUrl: "/assets/imgs/services/11WindowsCleaning/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  